import { useState, useEffect } from "react";
import BallLoader from "../components/shared/BallLoader";
import { useNavigate, useSearchParams } from "react-router-dom";
import { CheckCircle, XCircle } from "lucide-react";
import axios from "axios";
import { API } from "../contexts/AuthContext";
import { useTranslation } from "@/i18n";

export const VerifyEmailPage = () => {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState("verifying"); // verifying | success | error
  const [message, setMessage] = useState("");

  useEffect(() => {
    const token = searchParams.get("token");
    if (!token) {
      setStatus("error");
      setMessage("Invalid verification link. No token provided.");
      return;
    }

    (async () => {
      try {
        const res = await axios.post(`${API}/auth/verify-email`, { token });
        setStatus("success");
        setMessage(res.data.message || "Email verified successfully!");
        localStorage.removeItem("pendingVerifyEmail");
      } catch (err) {
        setStatus("error");
        setMessage(err.response?.data?.detail || "Verification failed. Link may be expired.");
      }
    })();
  }, [searchParams]);

  return (
    <div className="app-container px-8 flex flex-col justify-center min-h-screen">
      <div className="text-center max-w-sm mx-auto">
        <h1 className="text-3xl font-bold mb-8">Xelanti</h1>
        
        {status === "verifying" && (
          <>
            <BallLoader size={48} className="mb-4" />
            <p className="text-gray-600 dark:text-gray-300">{t('verify.verifying')}</p>
          </>
        )}
        
        {status === "success" && (
          <>
            <CheckCircle size={64} className="mx-auto mb-4 text-green-500" />
            <h2 className="text-2xl font-bold mb-3">{t('verify.verified')}</h2>
            <p className="text-gray-600 dark:text-gray-300 mb-8">{message}</p>
            <button
              onClick={() => navigate("/login")}
              className="clean-btn-primary w-full"
            >
              {t('verify.goToSignIn')}
            </button>
          </>
        )}
        
        {status === "error" && (
          <>
            <XCircle size={64} className="mx-auto mb-4 text-red-500" />
            <h2 className="text-2xl font-bold mb-3">{t('verify.failed')}</h2>
            <p className="text-gray-600 dark:text-gray-300 mb-8">{message}</p>
            <button
              onClick={() => navigate("/login")}
              className="clean-btn-primary w-full"
            >
              {t('verify.backToSignIn')}
            </button>
            <p className="text-sm text-gray-400 mt-4">{t('verify.requestAgain')}</p>
          </>
        )}
      </div>
    </div>
  );
};
